export const SET_GOAL_TRANSACTIONS = 'SET_GOAL_TRANSACTIONS'
